// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1ON3_","description":"PatientConsentPreview_description__1lrkE"};